import ImagesUrl from "#constants/images.js";
import React from "react";

const CropProtectionDetailComponent = ({
  CropProtectionDetailData,
  parentIndex,
}) => {
  return (
    <div className="custom_accordion_item mb-3">
      <button
        className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapseCrop_3${parentIndex}`}
        aria-expanded="false"
        aria-controls={`collapseCrop_3${parentIndex}`}
      >
        <p className="m-0 fertility_text">Crop Protection</p>
        <span className="drop_icon">
          <img
            className="drop_icon"
            src={ImagesUrl.dopeIcon}
            alt="drop-icon .."
          />
        </span>
      </button>
      <div
        className="custom_collapse_body collapse"
        id={`collapseCrop_3${parentIndex}`}
      >
        <div className="common-collapse_blk">
          <div className="row gy-4">
            {CropProtectionDetailData?.map(
              (cropProtectionItem, cropProtectionIndex) => {
                return (
                  <div className="col-lg-12">
                    <div className="custom_sub_accordion_item">
                      <button
                        className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${cropProtectionIndex}${parentIndex}`}
                        aria-expanded="false"
                        aria-controls={`${cropProtectionIndex}${parentIndex}`}
                      >
                        <p className="m-0 fertility_text fs-6">
                          {cropProtectionItem?.cropTitle}
                        </p>
                        <span className="drop_icon">
                          <img
                            className="drop_icon"
                            src={ImagesUrl.dopeIcon}
                            alt="drop-icon .."
                          />
                        </span>
                      </button>
                      <div
                        className="custom_collapse_body collapse"
                        id={`${cropProtectionIndex}${parentIndex}`}
                      >
                        <div className="common-collapse_blk sub-collapse_blk">
                          <div className="row gy-4">
                            <div className="col-12">
                              <div className="mt-3">
                                {cropProtectionItem?.cropDetail?.length > 0 ? (
                                  cropProtectionItem.cropDetail.map(
                                    (productItem, productIndex) => (
                                      <>
                                        <div
                                          className="product_card_info"
                                          key={productIndex}
                                        >
                                          <div className="d-flex justify-content-between px-3 py-1">
                                            <span>Product</span>
                                            <span>
                                              {productItem?.productName ||
                                                "N/A"}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between px-3 py-1">
                                            <span>Rate</span>
                                            <span>
                                              {productItem?.rate
                                                ? `${productItem.rate} Ac/ ${productItem?.containerSize || 10}${productItem?.containerUnit || "L"} ${productItem?.containerType || "jug"}`
                                                : "N/A"}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between px-3 py-1">
                                            <span>Notes</span>
                                            <span>
                                              {productItem?.notes || "N/A"}
                                            </span>
                                          </div>
                                        </div>
                                      </>
                                    )
                                  )
                                ) : (
                                  <div className="d-flex justify-content-center align-items-center w-100 py-4">
                                    <span>Product is not available</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropProtectionDetailComponent;
